import { useEffect, useState } from "react";
import { navLinks, siteInfo } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-3 cursor-pointer" onClick={() => setOpen(false)}>
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50">
              曝
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                {siteInfo.name}
              </span>
              <span
                className={`mt-1 text-[11px] tracking-wide ${
                  solid ? "text-foreground-600" : "text-background-200"
                }`}
              >
                {siteInfo.tagline}
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  solid
                    ? "text-foreground-700 hover:bg-secondary-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className="hidden md:inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-megaphone-line text-base" />
              我要投稿
            </a>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((prev) => !prev)}
              className={`md:hidden flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border text-xl ${
                solid
                  ? "border-background-300 text-foreground-900"
                  : "border-background-50/40 text-background-50"
              }`}
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="flex cursor-pointer items-center gap-3 rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-secondary-100 hover:text-primary-700"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-primary-600">
                  <i className={link.icon} />
                </span>
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-megaphone-line text-base" />
              我要投稿
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}